import 'whatwg-fetch' // fetch polyfill
import 'custom-event-polyfill'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/utils/element-ui'
import '@/assets/ht-iconfont/iconfont.css'
import WuJieVue from 'wujie-vue2'
import hostMap from '../wujie-config/hostMap'
import credentialsFetch from '../wujie-config/fetch'
import lifecycles from '../wujie-config/lifecycle'
import plugins from '../wujie-config/plugin'
import '@/assets/css/common.scss'

const isProduction = process.env.NODE_ENV === 'production'
const { setupApp, preloadApp, bus } = WuJieVue
Vue.use(WuJieVue)

Vue.config.productionTip = false

bus.$on('click', (msg) => window.alert(msg))

// 在 xxx-sub 路由下子应用将激活路由同步给主应用，主应用跳转对应路由高亮菜单栏
bus.$on('sub-route-change', (name, path) => {
  const mainName = `${name}-sub`
  const mainPath = `/${name}-sub${path}`
  const currentName = router.currentRoute.name
  const currentPath = router.currentRoute.path
  if (mainName === currentName && mainPath !== currentPath) {
    router.push({ path: mainPath })
  }
})
bus.$on('toLogin', () => {
  console.log('子应用调用跳转到登录页')
  store.dispatch('sys/toLogin')
})

const degrade = window.localStorage.getItem('degrade') === 'true' || !window.Proxy || !window.CustomElementRegistry
const props = {
  jump: (name) => {
    router.push({ name })
  }
}
/**
 * 大部分业务无需设置 attrs
 * 此处修正 iframe 的 src，是防止github pages csp报错
 * 因为默认是只有 host+port，没有携带路径
 */
const attrs = isProduction ? { src: hostMap('//localhost:8000/') } : {}
/**
 * 配置应用，主要是设置默认配置
 * preloadApp、startApp的配置会基于这个配置做覆盖
 */
// setupApp({
//   name: 'EipManage',
//   url: hostMap('//localhost:8080'),
//   attrs,
//   exec: true,
//   alive: true,
//   props,
//   fetch: credentialsFetch,
//   degrade,
//   ...lifecycles
// })
// setupApp({
//   name: 'WuJieTemp',
//   url: hostMap('//localhost:5173'),
//   attrs,
//   exec: true,
//   alive: true,
//   props,
//   fetch: credentialsFetch,
//   degrade,
//   ...lifecycles
// })

if (window.localStorage.getItem('preload') !== 'false') {
  // preloadApp({
  //   url: hostMap('eipManageUrl') + '/eipManage',
  //   name: 'EipManage'
  // })
}

new Vue({
  store,
  router,
  render: (h) => h(App)
}).$mount('#app')
